<template>
  <OverlayCard width="m" @cancel="$emit('cancel')">
    <template #title>
      {{ $t('helpscout.statisticsCard.title') }}
    </template>

    <template #content>
      {{ $t('helpscout.statisticsCard.text') }}
    </template>

    <template #footer>
      <Btn @click="allowStatistics()" data-test-id="helpscout-statistics-card-allow-button">
        {{ $t('helpscout.statisticsCard.action.allowStatistics') }}
      </Btn>

      <Btn color="grey" @click="$emit('cancel')">{{ $t('action.close') }}</Btn>
    </template>
  </OverlayCard>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  emits: { cancel: null },
  name: 'HelpscoutStatisticsCard',

  methods: {
    allowStatistics() {
      window.Cookiebot?.submitCustomConsent(
        window.Cookiebot.consent.preferences,
        true,
        window.Cookiebot.consent.marketing
      );

      this.$emit('cancel');
    },
  },
});
</script>
